







































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { OrderHistoryToAdminResp_Order, Timestamp } from '@/apiv3/index'
import auth from '@/auth'
import helpers from '@/helpers'

@Component({ components: { PulseLoader } })
export default class OrderHistory extends Vue {
  public loaded = false
  public orders!: OrderHistoryToAdminResp_Order[]

  mounted (): void {
    auth.adminClient().OrderHistoryToAdmin({}).then((resp) => {
      this.orders = resp.orders
    }).finally(() => {
      this.loaded = true
    })
  }

  formatDateOnly (val: Timestamp | undefined): string {
    return helpers.formatDateOnlyTs(val)
  }

  setQueryParameters (order: OrderHistoryToAdminResp_Order): string {
    const vals = new Map<string, string>()

    vals.set('user_id', order.userId.toString())
    vals.set('number', order.number + ' рецензия')

    return helpers.setQueryParameters(vals)
  }
}
